import { useTheme } from '@emotion/react';
import { useState } from 'react';

import { isBrowser, toMediaQueryStr } from 'lib/utils';

import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

const isMatch = (mediaQuery) =>
  isBrowser() ? window.matchMedia(toMediaQueryStr(mediaQuery)).matches : null;

const useMediaQuery = (
  { shouldUpdateAtInitialLoad } = { shouldUpdateAtInitialLoad: true }
) => {
  const theme = useTheme();
  const [
    isMediaQueryMatchersUpdatedOnClient,
    setMediaQueryMatchersUpdatedOnClient,
  ] = useState(false);
  const [mediaQueryMatchers, setMediaQueryMatchers] = useState({
    isXl: isMatch(theme.mediaQueries.xl),
    isLg: isMatch(theme.mediaQueries.lg),
    isMd: isMatch(theme.mediaQueries.md),
    isSm: isMatch(theme.mediaQueries.sm),
  });

  useIsomorphicLayoutEffect(() => {
    const handleResize = () =>
      setMediaQueryMatchers({
        isXl: isMatch(theme.mediaQueries.xl),
        isLg: isMatch(theme.mediaQueries.lg),
        isMd: isMatch(theme.mediaQueries.md),
        isSm: isMatch(theme.mediaQueries.sm),
      });

    if (!isMediaQueryMatchersUpdatedOnClient && shouldUpdateAtInitialLoad) {
      handleResize();
      setMediaQueryMatchersUpdatedOnClient(true);
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [isMediaQueryMatchersUpdatedOnClient, shouldUpdateAtInitialLoad]);

  return mediaQueryMatchers;
};

export default useMediaQuery;
